import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Typography,
  Image,
  notification,
  Radio,
  Input,
  message,
  Alert,
} from "antd";
import {
  CheckCircleOutlined,
  DownloadOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { QRCode } from "react-qr-svg";
import domtoimage from "dom-to-image";
import Post from "../services/Post";
import Get from "../services/Get";
import axios from "axios";
import crypto from "crypto-js";
import io from "socket.io-client";

const { Title, Text } = Typography;

const FetchQR = () => {
  const location = useLocation();
  const qrCodeRef = useRef();
  const { isNew, data } = location.state || {};
  const [showForm, setShowForm] = useState(isNew);
  const [qrData, setQrData] = useState(data);
  const [gender, setGender] = useState("male");
  const [mobile, setMobile] = useState();
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [setting, setSetting] = useState();
  const [paymentUrl, setPaymentUrl] = useState();
  const [processing, setProcessing] = useState(false);
  console.log(data);

  const handleDownload = () => {
    if (qrCodeRef.current) {
      domtoimage
        .toBlob(qrCodeRef.current)
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `QRCode_${
            qrData?.data?.qr_code_number || "unknown"
          }.png`;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };

  const settingGet = () => {
    Get.Setting().then((res) => {
      console.log(res);
      setSetting(res.data["qr_fee"][0]);
    });
  };

  const pay_now = async () => {
    try {
      let amount = setting.value1;

      if (!amount) {
        message.error("Amount not found!");
        return null;
      }
  
      setProcessing(true);
  
      const res = await Post.PaymentLink(amount);
      console.log(res);
  
      const { paymentLink, order_id } = res.data;
  
      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setProcessing(false);
        return null;
      }
  
      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );
  
      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setProcessing(false);
        return null;
      }
  
      let popupClosed = false;
  
      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setProcessing(false);
            reject(null);
          }
        }, 1000);
  
        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        console.log(order_id);
        socket.emit("join-room", order_id);
        console.log('room joined');

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;
  
          if (popupClosed) return;
  
          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setProcessing(false);
      return null;
    }
  };

  const handlePayment = async () => {
    // Set processing state to true
    setProcessing(true);

    try {
      const send = {
        gender: gender,
        mobile: mobile,
        vehicle_id: data.id,
        method: paymentMethod,
      };

      if (paymentMethod === "online") {
        const payId = await pay_now();
        send.txn = payId;
      }
      console.log("data to send", send);

      const res = await Post.QrCode(send);
      console.log("res =====", res);
      if (res) {
        console.log(res);
        if (res.errorMsg) {
          message.error(res.errorMsg);
        } else {
          setQrData(res);
          setShowForm(false);
          message.success(res.status);
        }
      }
    } catch (error) {
      console.error("Error in payment:", error);
      message.error({
        message: "Error Occured",
      });
    } finally {
      // Reset processing state
      setProcessing(false);
    }
  };

  useEffect(() => {
    settingGet();
    // pay_now();
  }, []);

  return (
    <Row justify={"center"}>
      {showForm ? (
        <Col xs={24} xl={8} md={12}>
          <Alert
            message={`You have to pay ₹ ${
              setting ? setting.value1 : "loading..."
            } to get the QR Code.`}
            type="info"
            showIcon
            style={{ marginBottom: 20 }}
          />
          <Card style={{ padding: 10 }}>
            <Typography.Title level={5}>Enter Contact Number</Typography.Title>
            <Input
              placeholder="Enter Alternate Phone Number"
              type="tel"
              width={"100%"}
              onChange={(e) => setMobile(e.target.value)}
            />
            <Typography.Title level={5} style={{ marginTop: 20 }}>
              Select Gender
            </Typography.Title>
            <Radio.Group
              onChange={(e) => setGender(e.target.value)}
              value={gender}
              style={{ display: "block", margin: "20px 0" }}
            >
              <Radio value="male">Male</Radio>
              <Radio value="female">Female</Radio>
            </Radio.Group>
            <Typography.Title level={5} style={{ marginTop: 20 }}>
              Select Payment Method
            </Typography.Title>
            <Radio.Group
              onChange={(e) => setPaymentMethod(e.target.value)}
              value={paymentMethod}
              style={{ display: "block", margin: "20px 0" }}
            >
              <Radio value="online">
                Online
              </Radio>
              <Radio value="wallet">Wallet</Radio>
            </Radio.Group>
            <Button
              className="form-btn"
              block
              onClick={handlePayment}
              disabled={processing}
            >
              Generate QR Code
            </Button>
          </Card>
        </Col>
      ) : (
        <Col xs={18}>
          <div style={{ backgroundColor: "white", padding: "20px" }}>
            {/* Header */}
            <div style={{ marginBottom: "20px" }}>
              <Title level={3}>Your Vehicle's QR Code</Title>
            </div>

            {/* Success message */}
            {isNew && !showForm && (
              <Card
                style={{
                  marginBottom: "20px",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                <Row justify="center">
                  <Col>
                    <CheckCircleOutlined
                      style={{ fontSize: "30px", color: "green" }}
                    />
                    <Title level={4} style={{ color: "green" }}>
                      SUCCESS
                    </Title>
                    <Text type="secondary">
                      Congrats, your QR code has been generated successfully.
                    </Text>
                  </Col>
                </Row>
              </Card>
            )}

            {/* QR Code Display */}
            <Card
              style={{
                backgroundColor: "#a6cc43",
                borderRadius: "10px",
                padding: "8px",
                width: "1013px",
                height: "638px",
                overflowX: "auto",
              }}
              ref={qrCodeRef} // Ref for capturing the component
            >
              <Row justify="center" gutter={[18, 18]}>
                <Col span={12}>
                  <Text style={{ color: "white", fontSize: 30 }}>
                    rebatedekho.com
                  </Text>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                  >
                    {qrData && (
                      <img src={qrData.qr_code} className="qr-code-fetch" />
                    )}
                    <Row justify={"center"}>
                      <Text style={{ fontSize: 40, marginTop: 10 }}>
                        {qrData ? qrData.data.qr_code_number : ""}
                      </Text>
                    </Row>
                  </div>
                </Col>
                <Col span={12}>
                  <Title
                    level={4}
                    style={{
                      color: "white",
                      textAlign: "center",
                      margin: "40px 0",
                    }}
                    className="card-title"
                  >
                    SCAN TO CONTACT THE VEHICLE OWNER
                  </Title>
                  <div
                    style={{
                      backgroundColor: "white",
                      height: "2px",
                      margin: "10px 0",
                    }}
                  ></div>
                  <Title
                    level={5}
                    style={{
                      color: "white",
                      textAlign: "center",
                      margin: "40px 0",
                    }}
                    className="card-hindi"
                  >
                    वाहन मालिक से संपर्क करने के लिए स्कैन करें
                  </Title>
                  <Text
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      padding: "5px",
                      borderRadius: "5px",
                      display: "block",
                      textAlign: "center",
                    }}
                    className="card-desc"
                  >
                    Use your camera, Google Lens, Paytm or any QR Scanner app to
                    Scan the QR tag.
                  </Text>
                </Col>
              </Row>
            </Card>

            {/* Action Buttons */}
            <Row justify="space-between" style={{ marginTop: "30px" }}>
              <Col span={11}>
                <Button
                  type="default"
                  icon={<DownloadOutlined />}
                  className="form-btn"
                  onClick={handleDownload}
                >
                  Tap for Download
                </Button>
              </Col>
              {/* <Col span={11}>
                    <Button
                        type="primary"
                        icon={<SendOutlined />}
                        style={{ width: '100%' }}
                        onClick={handleOrderSticker}
                    >
                        Order to Sticker
                    </Button>
                </Col> */}
            </Row>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default FetchQR;
